import { useState, useRef } from 'react';

export default function CopyBlock({ text, label, id }) {
  const [copied, setCopied] = useState(false);
  const ref = useRef(null);
  function copy() {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }
  return (
    <div style={{ position: 'relative' }}>
      <pre ref={ref} style={{
        background: 'var(--bg)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-sm)', padding: '16px 48px 16px 16px',
        overflowX: 'auto', fontFamily: 'monospace', fontSize: 12.5,
        lineHeight: 1.6, color: 'var(--accent2)', whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}>{text}</pre>
      <button onClick={copy} style={{
        position: 'absolute', top: 8, right: 8, padding: '4px 10px',
        borderRadius: 4, border: '1px solid var(--border)',
        background: copied ? 'var(--accent)' : 'var(--bg2)',
        color: copied ? '#fff' : 'var(--muted)',
        fontSize: 11, fontWeight: 600, cursor: 'pointer',
      }}>{copied ? 'Copied!' : (label || 'Copy')}</button>
    </div>
  );
}
